import React from 'react';
import Head from 'next/head';
import { shape, string } from 'prop-types';
var SearchTitle = function SearchTitle(_ref) {
  var _structure$route, _structure$route$filt, _data$search, _data$search$products, _data$search$products2, _getDefaultTitle;
  var structure = _ref.structure,
    staticProps = _ref["static"],
    data = _ref.data;
  var defaultTitle = staticProps.defaultTitle,
    defaultDescription = staticProps.defaultDescription,
    deniedDescription = staticProps.deniedDescription,
    allowedDescription = staticProps.allowedDescription;
  var capitalize = function capitalize(term) {
    return term == null ? void 0 : term.split(' ').map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  };
  var searchTerm = structure == null ? void 0 : structure.route.term;
  var filterSeller = (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : (_structure$route$filt = _structure$route.filters) == null ? void 0 : _structure$route$filt.find(function (filter) {
    return filter.type === 'seller';
  })) && !searchTerm ? data == null ? void 0 : (_data$search = data.search) == null ? void 0 : (_data$search$products = _data$search.products[0]) == null ? void 0 : (_data$search$products2 = _data$search$products.seller) == null ? void 0 : _data$search$products2.description : defaultTitle;
  var capitalizedSellerTitle = capitalize(filterSeller);
  var capitalizedTerm = capitalize(searchTerm);
  var searchTermOrSeller = searchTerm ? capitalizedTerm : capitalizedSellerTitle;
  var sensitiveTerm = data == null ? void 0 : data.sensitiveTerm;
  var getCustomTitle = function getCustomTitle() {
    return sensitiveTerm.title && sensitiveTerm.title !== '' ? sensitiveTerm.title : "".concat(searchTermOrSeller, " | Resultado de Busca Interna | Magazine Luiza");
  };
  var getDefaultTitle = function getDefaultTitle() {
    var _data$seoSearchConten, _data$seoSearchConten2;
    return (data == null ? void 0 : (_data$seoSearchConten = data.seoSearchContent) == null ? void 0 : (_data$seoSearchConten2 = _data$seoSearchConten.meta) == null ? void 0 : _data$seoSearchConten2.title) || "".concat(searchTermOrSeller, " em Promo\xE7\xE3o no Magazine Luiza");
  };
  var title = sensitiveTerm && sensitiveTerm.adjustTitle ? getCustomTitle() : (_getDefaultTitle = getDefaultTitle()) !== null && _getDefaultTitle !== void 0 ? _getDefaultTitle : defaultTitle;
  var description = sensitiveTerm != null && sensitiveTerm !== undefined ? deniedDescription : allowedDescription !== null && allowedDescription !== void 0 ? allowedDescription : defaultDescription;
  return React.createElement(Head, null, React.createElement("title", {
    "data-testid": "meta-title"
  }, title), React.createElement("meta", {
    "data-testid": "meta-description",
    name: "description",
    content: description
  }));
};
SearchTitle.displayName = 'SearchTitle';
SearchTitle.defaultProps = {
  data: {},
  "static": {
    allowedDescription: '',
    allowedTitle: '',
    defaultDescription: '',
    defaultTitle: '',
    deniedDescription: '',
    deniedTitle: ''
  },
  structure: {
    route: {}
  }
};
process.env.NODE_ENV !== "production" ? SearchTitle.propTypes = {
  data: shape({}),
  "static": shape({
    allowedDescription: string,
    allowedTitle: string,
    defaultDescription: string,
    defaultTitle: string,
    deniedDescription: string,
    deniedTitle: string
  }),
  structure: shape({
    route: shape({})
  })
} : void 0;
SearchTitle.ssr = true;
export default SearchTitle;